<div class="time-picker-container" [formGroup]="form">
  <div class="time-picker">
    <button type="button" mat-button color="primary" (click)="up('from')">
      <mat-icon>keyboard_arrow_up</mat-icon>
    </button>
    <mat-form-field appearance="outline">
      <app-easy-select
        formControlName="from"
        [options]="hours"
      ></app-easy-select>
    </mat-form-field>
    <button type="button" mat-button color="primary" (click)="down('from')">
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
  </div>
  <div class="time-picker">
    <button type="button" mat-button color="primary" (click)="up('to')">
      <mat-icon>keyboard_arrow_up</mat-icon>
    </button>
    <mat-form-field appearance="outline">
      <app-easy-select formControlName="to" [options]="hours"></app-easy-select>
    </mat-form-field>
    <button type="button" mat-button color="primary" (click)="down('to')">
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
  </div>
</div>
